import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Excluir", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-18 ant-col-xl-18" }
const _hoisted_7 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_8 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = {
  class: "ant-row",
  style: {"overflow-y":"auto","height":"150px","max-height":"150px"}
}
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = {
  key: 3,
  class: "ant-row"
}
const _hoisted_17 = {
  key: 4,
  class: "ant-row"
}
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_grupo_resultado = _resolveComponent("selecionar-tipo-grupo-resultado")!
  const _component_selecionar_grupo_d_r_e = _resolveComponent("selecionar-grupo-d-r-e")!
  const _component_selecionar_plano_conta = _resolveComponent("selecionar-plano-conta")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_card = _resolveComponent("card")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_cenario_fiscal = _resolveComponent("selecionar-cenario-fiscal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 600,
    centered: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Grupo de Resultados")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.grupo.descricao) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.grupo.descricao]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_grupo_resultado, {
                        valor: _ctx.state.grupo.tipo,
                        "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.grupo.tipo) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Totalizador)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_a_form_item, {
                        label: "Grupos Utilizados",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_grupo_d_r_e, {
                            empresas: [_ctx.props.operacao.empresaSelecionada],
                            varios: true,
                            omitirCodigo: _ctx.state.grupo.codigo,
                            codigosSelecionados: _ctx.state.gruposUtilizados,
                            "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.gruposUtilizados) = $event)),
                            estrutura: _ctx.props.estrutura
                          }, null, 8, ["empresas", "omitirCodigo", "codigosSelecionados", "estrutura"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_a_form_item, {
                          label: "Plano de Contas",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_plano_conta, {
                              empresas: [_ctx.props.operacao.empresaSelecionada],
                              "codigo-selecionado": _ctx.state.grupo.codigoPlanoConta,
                              "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.grupo.codigoPlanoConta) = $event)),
                              onChange: _ctx.obterCategorias
                            }, null, 8, ["empresas", "codigo-selecionado", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (_ctx.state.categorias.length > 0)
                      ? (_openBlock(), _createBlock(_component_card, {
                          key: 0,
                          titulo: "Categorias Utilizada"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_a_form_item, {
                                  label: "Busca Rápida",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.buscaRapidaCategorias) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.buscaRapidaCategorias]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_a_tree, {
                                  "tree-data": _ctx.treeData,
                                  "show-icon": "",
                                  expandedKeys: _ctx.state.categoriasExpandidas,
                                  "onUpdate:expandedKeys": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.categoriasExpandidas) = $event)),
                                  checkable: "",
                                  checkedKeys: _ctx.state.categoriasSelecionadas,
                                  "onUpdate:checkedKeys": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.categoriasSelecionadas) = $event))
                                }, null, 8, ["tree-data", "expandedKeys", "checkedKeys"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64)),
              _createVNode(_component_card, { titulo: "Totais de Movimentações" }, {
                default: _withCtx(() => [
                  (_ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Receitas)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 0,
                        message: "",
                        description: "Você pode utilizar o total de vendas ou serviços para ser somado ao valor total do grupo. O total de vendas será filtrado pelos cenários fiscais selecionados aqui.",
                        type: "info",
                        "show-icon": ""
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Despesas)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 1,
                        message: "",
                        description: "Você pode utilizar o total de devlouções de vendas ou CMV para ser somado ao valor total do grupo. Esses totais serão filtrados pelos cenários fiscais selecionados aqui.",
                        type: "info",
                        "show-icon": ""
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Totalizador)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 2,
                        message: "",
                        description: "Você pode utilizar os totais de movimentações de entradas ou saídas para serem somados ao valor total do grupo. Esses totais serão filtrados pelos cenários fiscais selecionados aqui.",
                        type: "info",
                        "show-icon": ""
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Receitas || _ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Totalizador)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_a_checkbox, {
                          class: "ss-margin-campos",
                          checked: _ctx.state.utilizarTotalVendas,
                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.utilizarTotalVendas) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("(+) Total de Vendas")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          class: "ss-margin-campos",
                          checked: _ctx.state.utilizarTotalServicos,
                          "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.utilizarTotalServicos) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("(+) Total de Serviços")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Despesas || _ctx.state.grupo.tipo === _ctx.ETipoGrupoDRE.Totalizador)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_a_checkbox, {
                          class: "ss-margin-campos",
                          checked: _ctx.state.utilizarTotalDevolucoes,
                          "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.utilizarTotalDevolucoes) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("(-) Total de Devoluções de Vendas")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          class: "ss-margin-campos",
                          checked: _ctx.state.utilizarCmv,
                          "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.utilizarCmv) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("(-) CMV")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Basear totais nos cenários fiscais",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_cenario_fiscal, {
                            empresas: [_ctx.props.operacao.empresaSelecionada],
                            varios: true,
                            "codigos-selecionados": _ctx.state.cenariosFiscais,
                            "onUpdate:codigosSelecionados": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.cenariosFiscais) = $event))
                          }, null, 8, ["empresas", "codigos-selecionados"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}